/**
 * Some spor components are overridden by drops components. Each of these are a full
 * replacement of the Spor components, with corrected colors and extra options available
 */

// Imports:
import { Tooltip as InternalTooltip } from "shared/components/drops/DropsTooltip";

import { InternalDropsBadge } from "shared/components/drops/DropsBadge";
import { InternalDropsButton } from "shared/components/drops/DropsButton";
import { InternalDropsCheckbox } from "shared/components/drops/DropsCheckbox";
import { InternalDropsDatePicker } from "shared/components/drops/DropsDatePicker";
import { InternalDropsDialogContent } from "shared/components/drops/DropsDialogContent";
import { InternalDropsDialogHeader } from "shared/components/drops/DropsDialogHeader";
import { InternalDropsExpandable } from "shared/components/drops/DropsExpandable";
import { InternalDropsMenuCheckboxItem } from "shared/components/drops/DropsMenuCheckboxItem";
import { InternalDropsStaticAlert } from "shared/components/drops/DropsStaticAlert";
import { withDefaults } from "shared/utils/withDefaults";

// Exports (With Documentations):
export * from "@vygruppen/spor-react";
export { Tooltip as SporTooltip } from "@vygruppen/spor-react";

// Documentations are visible by hovering the component
/**
 * Old Drops version of { Badge } from "shared/components/Spor";
 * Includes a prop 'Semantics' which styles the button to fit that 'Severity' value.
 * @deprecated Use the \<Badge />  component instead, it now has sidespor expansions
 */
export const DropsBadge = InternalDropsBadge;

/**
 * @deprecated Use the \<Alert /> component instead, it now has the correct styling.
 */
export const DropsStaticAlert = InternalDropsStaticAlert;
/**
 * Use Drops version instead
 */
export const StaticAlert = null; // Remove access to StaticAlert

/**
 * @deprecated Use the \<Button /> component instead, it now has semantic styling.
 */
export const DropsButton = InternalDropsButton;

/**
 * Drops version of { Expandable } from "shared/components/Spor";
 * Adds a DashedLine between Trigger and Body, as well as fixing Outline/Background for Trigger and Body.
 * Fixes the typing of title to allow JSX.Element as well
 */
export const DropsExpandable = InternalDropsExpandable;

/**
 * Use Drops version instead
 */
export const Expandable = null;

/**
 * @deprecated Use the \<Checkbox /> component instead, it now has the correct styling.
 */
export const DropsCheckbox = InternalDropsCheckbox;

/**
 * @deprecated Use the \<DialogHeader /> component instead, they have the correct styling.
 */
export const DropsDialogHeader = InternalDropsDialogHeader;
/**
 * Use Drops version instead
 */
export const DialogHeader = null;

/**
 * @deprecated Use the \<DialogContent /> component instead, they have the correct styling.
 */
export const DropsDialogContent = InternalDropsDialogContent;
/**
 * Use Drops version instead
 */
export const DialogContent = null;

/**
 * @deprecated Use the \<DatePicker /> component instead, it now has the correct styling.
 */
export const DropsDatePicker = InternalDropsDatePicker;

/**
 * @deprecated Use the \<MenuCheckboxItem /> component instead, it now has the correct styling.
 */
export const MenuCheckboxItem = InternalDropsMenuCheckboxItem;

/**
 * @deprecated we should instead use the new `Tooltip` Spor component going forward
 */
export const DropsTooltip = withDefaults(InternalTooltip, (theme) => ({
  style: {
    color: theme.colorBackgroundMain,
    backgroundColor: theme.colorSuccessTextSecondary,
    padding: "6px",
    borderRadius: "12px",
  },
}));
